import { useEffect } from "react";
import * as React from "react";
import { Helmet } from "react-helmet";

import { BigScreenSignup } from "./big-screen";

import { setReferrerURL } from "utils/page-sense-events";

const SignUp: React.FC = (): JSX.Element => {
  const referrerURL = document.referrer;

  setReferrerURL(referrerURL);

  useEffect((): VoidFunction => {
    sessionStorage.setItem("trial", "true");

    return (): void => {
      sessionStorage.removeItem("trial");
    };
  }, []);

  return (
    <React.Fragment>
      <Helmet>
        <title>{"Sign up | Fluid Attacks"}</title>
        <meta
          content={
            "Sign up for Fluid Attacks and start using our Attack Resistance Management platform to detect, prioritize, and fix vulnerabilities."
          }
          name={"description"}
        />
        <link href={"https://app.fluidattacks.com/SignUp"} rel={"canonical"} />
      </Helmet>
      <BigScreenSignup />
    </React.Fragment>
  );
};

export { SignUp };
